module.exports = __webpack_public_path__ + "img/tech-icon-3@2x.c2ae44db.png";